import {ViewType} from "../../../../gd/const/views/view-type";
import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";

export const MY_RECENT_CONFIG : ViewPersonalConfig = {

    type            : ViewType.MY_RECENT,
    name            : 'Recent',
    icon            : 'i5-recent',
    iconSvg         : 'isvg-view-recent',
    url             : 'recent',
    description     : 'Summary of all recent work items.',
    defaultLocation : PersonalViewLocation.HOME

}
